import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { RifaService } from './rifa.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Rifas } from '../admin/modelos/rifas.model';
import { AngularFireStorage } from '@angular/fire/storage';

@Component({
  selector: 'app-rifa',
  templateUrl: './rifa.component.html',
  styleUrls: ['./rifa.component.css']
})
export class RifaComponent implements OnInit {
  @ViewChild('copyRigth') copyrigth!: ElementRef;

  participante_seleccionado = '';
  mostrar_sorteo = false;
  mostrar_fase = false;
  mostrar_final = false;
  mostrar_modal = false;
  mostrar_btn_play = false;
  mostrar_btn_settings = true;
  isOkLoading = false;

  sorteos = [];
  sorteo: string;

  public nombrePremios: Rifas[] = [];

  mensajes = [];
  mensaje: string;

  step = 0;

  mensajes_eliminacion = [
    'Primer eliminado',
    'Segundo eliminado',
    'Tercer eliminado',
    'Cuarto eliminado',
    'Quinto eliminado',
  ];

  mensaje_eliminacion = '';
  btn_play: Boolean = false;
  resgistro: string;
  participantes: any = [];

  eventoActivo: string[];
  noHayEvento: Boolean = false;
  public hayParticipantes: Boolean = false;
  public evento: any;
  public namePremio: any;
  public anio: any;
  public cargandoParticipantes: boolean =  true;
  public messageSelectedPremio: boolean =  false;

  // Form Configuration
  public solicitudForm: FormGroup;

  constructor(
    private rifaService: RifaService,
    private fb: FormBuilder,
    private storage: AngularFireStorage,
  ) {
    this.solicitudForm = this.fb.group({
      premio: ['', Validators.required],
    });
  }

  ngOnInit() {
    let a = new Date();
    let anio = a.getFullYear();
    // console.log("🚀 ~ file: rifa.component.ts ~ line 69 ~ RifaComponent ~ ngOnInit ~ anio", anio)
    this.anio = anio;
    
    // Extraer todas las rifas disponibles
    this.rifaService.getRifas().subscribe((item) => {
      // console.log("🚀 ~ file: rifa.component.ts ~ line 67 ~ RifaComponent ~ this.rifaService.getRifas ~ item", item);
      this.nombrePremios = item;
      // for (let r of item) {
      //   if (!r.estado) {
      //     this.nombrePremios.push(r);
      //   }
      // }
    });

    // Verificar si hay evento activo
    this.rifaService.getEvento().then((res: any) => {
      // console.log("🚀 ~ file: rifa.component.ts ~ line 81 ~ RifaComponent ~ this.rifaService.getEvento ~ res", res)
      // Extrayendo el evento activo
      const { ok, record } = res;

      if (ok) {
        const evento = record[0];
        this.evento = evento;
        const urlImg = evento.urlImagen;
        const tamString = (urlImg).length;
        const keyEvento = evento?.key ? evento.key : urlImg.substring(7, tamString);

        //Setear nombre de evento activo
        this.rifaService.setEvento(keyEvento);

        // Si hay evento activo
        this.noHayEvento = false;
        this.btn_play = true;

        //Extraer los participantes
        this.rifaService.getParticipantes().subscribe((res) => {
          // console.log("🚀 ~ file: rifa.component.ts ~ line 95 ~ RifaComponent ~ this.rifaService.getParticipantes ~ res", res)
          this.participantes = res;
          // this.participantes = res.map((item) => {
          //   return item.nombre;
          // });
          // Verificar si hay participantes
          
          if (this.participantes.length) {
            const num = (this.participantes.length == 1) ? 1 : (this.participantes.length > 3) ? 3 : (this.participantes.length - 1);

            this.crearArreglo(num);
            this.hayParticipantes = true;
          } else {
            this.hayParticipantes = false;
          }
          this.cargandoParticipantes = false
        });
      } else {
        this.noHayEvento = true;
        this.btn_play = false;
      }
    });
  }

  crearArreglo(num) {
    for (let i = 0; i < num; i++) {
      if (i == num - 1) {
        this.sorteos.push('i');
        this.mensajes.push('i');
      } else {
        this.sorteos.push('v');
        this.mensajes.push('e');
      }

    }
  }

  sortear() {
    this.mostrar_sorteo = true;
    this.mostrar_modal = false;
    this.btn_play = false;
    this.mostrar_fase = false;
    this.sorteo = this.sorteos[this.step];
    this.copyrigth.nativeElement.style.display = "none";

    setTimeout(() => {
      this.seleccionar();
    }, 3000);
  }

  seleccionar() {
    this.mensaje_eliminacion = this.mensajes_eliminacion[this.step] || '';
    this.mensaje = this.mensajes[this.step];
    this.participante_seleccionado = this.pickOne();
    this.mostrar_fase = true;
    this.mostrar_sorteo = false;
  }

  continuar() {
    this.step++;
    if (this.sorteos.length === this.step) {
      this.mostrar_final = true;
      this.mostrar_fase = false;
      this.mostrar_sorteo = false;
      this.copyrigth.nativeElement.style.display = "block";
      this.btn_play = false;
    } else {
      this.sortear();
    }
  }

  pickOne(): string {
    const n_elegido = Math.floor(Math.random() * this.participantes.length);
    const elegido = this.participantes[n_elegido];

    this.participantes.splice(n_elegido, 1);

    return elegido;
  }

  verificarData() {
    this.mostrar_modal = true;
  }

  handleCancel() {
    this.mostrar_modal = false;
  }

  setearData() {

    if (this.solicitudForm.valid) {
      const { premio } = this.solicitudForm.value;
      if (premio) {
        this.isOkLoading = true;
        this.extraerUrl(premio);
      }
    } else {
      Object.values(this.solicitudForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
   
  }

  extraerUrl(premio) {
    // console.log("🚀 ~ file: rifa.component.ts ~ line 187 ~ RifaComponent ~ extraerUrl ~ premio", premio)
    for (let i = 0; i < this.nombrePremios.length; i++) {
      if (this.nombrePremios[i].key == premio) {
        this.namePremio = this.nombrePremios[i].premio;
        localStorage.setItem('premio', this.nombrePremios[i].premio);
        localStorage.setItem('patrocinador', this.nombrePremios[i].patrocinador);
        localStorage.setItem('key', premio);
        this.extraerImg(this.nombrePremios[i].urlLogo);
      }

    }
  }


  extraerImg(url) {
    const ref = this.storage.ref(url);
    //Obteniendo la Direccion de la Imagen
    try {
      ref.getDownloadURL().subscribe((res) => {
        localStorage.setItem('imagen', res);
        this.isOkLoading = false;
        this.mostrar_btn_settings = false;
        this.mostrar_btn_play = true;
        this.mostrar_modal = false;
      }, (error) => { });
    } catch (error) { }

  }

  async setearImage(e) {
    const file = e.target.files[0];
    this.getBase64(file).then((res: string) => {
      localStorage.setItem('imagen', res);
    })
  }

  getBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

  reiniciar_tombola(){
    this.participante_seleccionado = '';
    this.mostrar_sorteo = false;
    this.mostrar_fase = false;
    this.mostrar_final = false;
    this.mostrar_modal = false;
    this.mostrar_btn_play = true;
    this.mostrar_btn_settings = false;
    this.isOkLoading = false;
    this.step = 0;
    this.btn_play = true;
  }
}
